import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

import { IFile } from './types/booking/file';

const BASE_URL = getCoreApi();

export const createFile = async (file: Partial<IFile>) => {
  const url = '/files';

  return await apiRequest<IFile>(
    {
      url: `${BASE_URL}${url}`,
      method: 'POST',
      data: file,
    },
    true,
    true,
  );
};

export const deleteFile = async (fileId: number) => {
  const url = `/files/${fileId}`;

  return await apiRequest<IFile>(
    {
      url: `${BASE_URL}${url}`,
      method: 'DELETE',
    },
    true,
    true,
  );
};

export const uploadSignature = async (blob: Blob, bookingId: number) => {
  const res = await createFile({
    name: `${bookingId}-renter-departure.png`,
    booking_id: bookingId,
    type: 'booking_handoff_renter_departure_signature',
  });

  await fetch(res.data.url, {
    body: blob,
    method: 'PUT',
  });
};
